// Safe clipboard write. navigator.clipboard.writeText() rejects in Safari
// private browsing, on non-secure origins, and without a user gesture — an
// unguarded call throws an unhandled rejection. Returns true on success,
// false on failure (never throws). Mirrors the try/catch model already used
// in src/components/Apps/TaskCard.vue.

export async function copyToClipboard(text) {
  try {
    if (!navigator.clipboard?.writeText) return false; // absent on insecure origins
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    console.error('copy to clipboard failed', e);
    return false;
  }
}
